export const HEADLINER_STUDIO_VIDEO_TABLES_SUBHEAD =
  'Any videos you share from Make are reported on here ';

export const LEARNING_CENTER_LINK =
  'https://sparemin.zendesk.com/hc/en-us/articles/20895302511127';
